import React from "react"
import {formatPercentage, formatPrice} from "ui-seeker/utils";
import {useAppCalendarCellContent} from "./@hooks";
import {formatIntegerPrice} from "app/@utils/price";
import { isClosedCause } from "app/@utils/closed";
import AppClosedLabel from "../../ClosedLabel";

export default function AppCalendarCellContent({ date, main, compset, openDetailsModal, integerPrices = false }) {
    const {
        comp, price, colorComp,
        currency, percentComp,
    } = useAppCalendarCellContent(main, compset)
    const formatMoney = integerPrices ? formatIntegerPrice : formatPrice

    return <div
        className="CalendarDayComp"
        style={{
            cursor: "pointer",
            transition: 'all 0.2s ease-in-out',
            transformOrigin: 'center center',
            willChange: 'transform, filter'
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.filter = 'brightness(0.95)';
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.filter = 'brightness(1)';
        }}
        onClick={() => openDetailsModal({
            showModalDay: true,
            infoDay: {
                main,
                compset,
                date
            }
        })}>
        <div className={`price text-white ${colorComp}`}>
            <span className="px-8">
                { main?.na
                    ? (isClosedCause(main.cause) ? <AppClosedLabel /> : main.cause === 'sold-out' ? 'SOLD OUT' : (main.cause === 'no-data' ? '-' : main.cause))
                    : formatMoney(price, { currency })
                }
            </span>
        </div>
        <div className={`comp text-white ${colorComp}-light`}>
            <span>Comp</span>
            <span style={{ minWidth: '80px' }}>{formatMoney(comp, {currency})}</span>
            <span>{price ? formatPercentage(percentComp) : '-'}</span>
        </div>
    </div>
}